var _path, _g, _mask, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotBildirim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 118,
    viewBox: "0 0 112 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.5C0 30.5721 25.0721 5.5 56 5.5C86.9279 5.5 112 30.5721 112 61.5C112 92.4279 86.9279 117.5 56 117.5C25.0721 117.5 0 92.4279 0 61.5Z",
    fill: "#DEEBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49299_50249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0551 36.2539C46.9526 36.2539 39.5551 43.6514 39.5551 52.7539V60.7014C39.5551 62.3789 38.8401 64.9364 37.9876 66.3664L34.8251 71.6189C32.8726 74.8639 34.2201 78.4664 37.7951 79.6764C49.6476 83.6364 62.4351 83.6364 74.2876 79.6764C77.6151 78.5764 79.0726 74.6439 77.2576 71.6189L74.0951 66.3664C73.2701 64.9364 72.5551 62.3789 72.5551 60.7014V52.7539C72.5551 43.6789 65.1301 36.2539 56.0551 36.2539Z",
    stroke: "#103F83",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1428 37.0509C60.2903 36.8034 59.4103 36.6109 58.5028 36.5009C55.8628 36.1709 53.3328 36.3634 50.9678 37.0509C51.7653 35.0159 53.7453 33.5859 56.0553 33.5859C58.3653 33.5859 60.3453 35.0159 61.1428 37.0509Z",
    stroke: "#103F83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3047 80.6641C64.3047 85.2016 60.5922 88.9141 56.0547 88.9141C53.7997 88.9141 51.7097 87.9791 50.2247 86.4941C48.7397 85.0091 47.8047 82.9191 47.8047 80.6641",
    stroke: "#103F83",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_49299_50249",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5 17.5C70.5 7.83502 78.335 0 88 0C97.665 0 105.5 7.83502 105.5 17.5C105.5 27.165 97.665 35 88 35C78.335 35 70.5 27.165 70.5 17.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 17.5C70.5 7.83502 78.335 0 88 0C97.665 0 105.5 7.83502 105.5 17.5C105.5 27.165 97.665 35 88 35C78.335 35 70.5 27.165 70.5 17.5Z",
    fill: "#D4183D",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 17.5M105.5 17.5M105.5 17.5M70.5 17.5M88 0M105.5 17.5M88 35M70.5 17.5M88 35V34C78.8873 34 71.5 26.6127 71.5 17.5H70.5H69.5C69.5 27.7173 77.7827 36 88 36V35ZM105.5 17.5H104.5C104.5 26.6127 97.1127 34 88 34V35V36C98.2173 36 106.5 27.7173 106.5 17.5H105.5ZM88 0V1C97.1127 1 104.5 8.3873 104.5 17.5H105.5H106.5C106.5 7.28273 98.2173 -1 88 -1V0ZM88 0V-1C77.7827 -1 69.5 7.28273 69.5 17.5H70.5H71.5C71.5 8.3873 78.8873 1 88 1V0Z",
    fill: "#D4183D",
    fillOpacity: 0.2,
    mask: "url(#path-5-inside-1_49299_50249)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.375 13.125L83.625 21.875",
    stroke: "#D4183D",
    strokeOpacity: 0.6,
    strokeWidth: 1.82292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.625 13.125L92.375 21.875",
    stroke: "#D4183D",
    strokeOpacity: 0.6,
    strokeWidth: 1.82292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49299_50249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(24 29.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotBildirim);
export default __webpack_public_path__ + "static/media/notBildirim.21398175ae0ec84102a356fc0a06bb1d.svg";
export { ForwardRef as ReactComponent };